var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2606 26.2438L8.76065 26.2556C6.01065 26.2582 3.75878 24.0107 3.75565 21.2607L3.74378 8.76065C3.74128 6.01065 5.98878 3.75878 8.73878 3.75565L21.2388 3.74378C23.9888 3.74128 26.2407 5.98878 26.2438 8.73878L26.2556 21.2388C26.2588 23.9894 24.0106 26.2413 21.2606 26.2438Z",
    fill: "url(#paint0_radial_19_29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2606 26.2438L8.76065 26.2556C6.01065 26.2582 3.75878 24.0107 3.75565 21.2607L3.74378 8.76065C3.74128 6.01065 5.98878 3.75878 8.73878 3.75565L21.2388 3.74378C23.9888 3.74128 26.2407 5.98878 26.2438 8.73878L26.2556 21.2388C26.2588 23.9894 24.0106 26.2413 21.2606 26.2438Z",
    fill: "url(#paint1_radial_19_29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.375C12.5881 19.375 10.625 17.4125 10.625 15C10.625 12.5875 12.5881 10.625 15 10.625C17.4119 10.625 19.375 12.5875 19.375 15C19.375 17.4125 17.4119 19.375 15 19.375ZM15 11.875C13.2769 11.875 11.875 13.2769 11.875 15C11.875 16.7231 13.2769 18.125 15 18.125C16.7231 18.125 18.125 16.7231 18.125 15C18.125 13.2769 16.7231 11.875 15 11.875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 11.25C20.2053 11.25 20.625 10.8303 20.625 10.3125C20.625 9.79473 20.2053 9.375 19.6875 9.375C19.1697 9.375 18.75 9.79473 18.75 10.3125C18.75 10.8303 19.1697 11.25 19.6875 11.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23.125H11.25C8.83812 23.125 6.875 21.1625 6.875 18.75V11.25C6.875 8.8375 8.83812 6.875 11.25 6.875H18.75C21.1619 6.875 23.125 8.8375 23.125 11.25V18.75C23.125 21.1625 21.1619 23.125 18.75 23.125ZM11.25 8.125C9.52688 8.125 8.125 9.52688 8.125 11.25V18.75C8.125 20.4731 9.52688 21.875 11.25 21.875H18.75C20.4731 21.875 21.875 20.4731 21.875 18.75V11.25C21.875 9.52688 20.4731 8.125 18.75 8.125H11.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_19_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1125 26.2719) scale(28.0619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_19_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.36628 3.46272) scale(18.6331 12.4152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.777c212200f47d722596d1cad6f08db5.svg";
export { ForwardRef as ReactComponent };